import type { PropsWithChildren } from 'react';
import { MarkdownRender } from '@gov-nx/component/web';
import type { ExtraConfig } from '@gov-nx/core/app';
import { useLocale } from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';
import { serviceRouteResolver } from '@gov-nx/web';

export const ProfileContentLayout = ({
	children,
	...profileContentLayoutConfig
}: PropsWithChildren<
	ExtraConfig['profileRoutes']['rosConfig']['profileRosView']['profileContentLayout']
>) => {
	const { t } = useLocale(PageCode['profil-ROB']);

	return (
		<LayoutGap>
			<ContentLayout customClasses="!pt-4">{children}</ContentLayout>
			{profileContentLayoutConfig.isAccountDeletionLinkVisible ? (
				<MarkdownRender>
					{t('paticka.smazani-uctu', {
						link: serviceRouteResolver('smazani-uzivatelskeho-uctu'),
					})}
				</MarkdownRender>
			) : null}
		</LayoutGap>
	);
};
